<template>
    <div>
        <Modal v-model="show"
            :title="title"
            :width="600"
            @on-visible-change="onModalShow">
            <Spin size="large"
                fix
                v-if="spinShow"></Spin>
            <div>
                <Form :label-width="90">
                    <Row :gutter="16">
                        <Col span="12">
                        <FormItem label="商品信息:">
                            <Input readonly
                                :value="deliveryInfo.productCode + '-' + deliveryInfo.productName"></Input>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="发货量:">
                            <Input readonly
                                :value="deliveryInfo.distributionStationDeliveryQuantity"></Input>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem required
                            label="售后类型:">
                            <RadioGroup v-model="complainModel.complainType">
                                <Radio :label="1">
                                    <span>数量</span>
                                </Radio>
                                <Radio :label="2">
                                    <span>品质</span>
                                </Radio>
                                <Radio :label="3">
                                    <span>品种</span>
                                </Radio>
                                <Radio :label="4">
                                    <span>其他</span>
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem required
                            label="详细描述:">
                            <Input v-model="complainModel.complainInfo"
                                type="textarea"
                                :rows="4"></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col v-if="complainModel.complainReponseStatus"
                            span="12">
                        <FormItem required
                            label="回复状态:">
                            <Input readonly
                                :value="complainModel.complainReponseStatus"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="complainModel.complainReponseStatus ==='已回复'"
                            span="12">
                        <FormItem required
                            label="回复时间:">
                            <Input readonly
                                :value="formatDateTimeString(complainModel.complainResponseTime)"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="complainModel.complainReponseStatus ==='已回复'"
                            span="12">
                        <FormItem required
                            label="回复结果:">
                            <Input readonly
                                :value="complainModel.complainResult"></Input>
                        </FormItem>
                        </Col>
                        <Col v-if="complainModel.complainReponseStatus ==='已回复'"
                            span="24">
                        <FormItem required
                            label="投诉回复:">
                            <Input readonly
                                :value="complainModel.complainResponse"
                                type="textarea"
                                :rows="4"></Input>
                        </FormItem>
                        </Col>
                    </Row>

                </Form>

            </div>
            <div slot="footer">
                <Button v-if="deliveryInfo.distributionStationDeliveryDetailIsComplain === 0"
                    type="success"
                    @click="onOk()">保存</Button>
                <Button v-if="deliveryInfo.distributionStationDeliveryDetailIsComplain === 1"
                    type="error"
                    @click="onDelete()">撤回</Button>
            </div>
        </Modal>

    </div>
</template>
<script>
import api from '@/api/api';
import { formatDateTimeString, numberToFixed } from '@/libs/utils';
export default {
    name: 'BaseModal',
    data() {
        return {
            show: false,
            title: '标题',
            spinShow: false,
            deliveryInfo: {},
            complainModel: {
                complainStationDeliveryUuid: '',
                complainType: 1,
                complainInfo: ''
            }
        };
    },
    components: {
    },
    methods: {
        formatDateTimeString,
        showModal(info) {
            this.deliveryInfo = info;
            this.complainModel.complainStationDeliveryUuid = this.deliveryInfo.distributionStationDeliveryDetailUuid;
            // console.log(this.deliveryInfo);
            this.show = true;
        },
        onModalShow(e) {
            if (e) {
                if (this.deliveryInfo.distributionStationDeliveryDetailIsComplain === 1) {
                    this.title = '投诉信息';
                    this.getComplainInfo();
                }
                else {
                    this.title = '新增投诉';
                    this.complainModel.complainType = 1;
                    this.complainModel.complainInfo = '';

                }
            }
        },
        onOk() {
            this.spinShow = true;
            api.addComplain(this.complainModel).then(res => {
                this.spinShow = false;
                if (res.code === 0) {
                    this.show = false;
                    this.$parent.getOrderDeliveryDetail();
                    this.$Modal.success({
                        title: '保存成功'
                    });
                }
            });
        },
        onDelete() {
            this.$Modal.confirm({
                title: '撤回',
                content: '是否确认撤回投诉？',
                okText: '是',
                onOk: () => {
                    this.spinShow = true;
                    api.deleteComplain({ complainStationDeliveryUuid: this.complainModel.complainStationDeliveryUuid }).then(res => {
                        this.spinShow = false;
                        if (res.code === 0) {
                            this.show = false;
                            this.$parent.getOrderDeliveryDetail();
                        }
                    });
                },
                cancelText: '否'
            });
        },
        getComplainInfo() {
            this.spinShow = true;
            api.getComplainInfo({ complainStationDeliveryUuid: this.complainModel.complainStationDeliveryUuid }).then(res => {
                this.spinShow = false;
                if (res.code === 0) {
                    Object.assign(this.complainModel, res.data.complainInfo);
                }
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/view/member/complain.vue